import app from '../../common/public.js';
import customer from '../../common/customer.js';
import { productTypeConfig } from '../../common/config/productTypeConfig.js';

function setIsTravelBussiness(productType, isTravelBussiness) {
  let settings = app.GetSettings() || {};
  settings.bookingProductType = productType;
  settings.bookingMethod = isTravelBussiness; // 0 因私  1 差旅订单
  app.SetSettings(settings);
}

//初始化列表页header  return 是否是因私使用
function initHeader(productType, webview) {
  let flag = false;
  let settings = app.GetSettings() || {};
  if (settings.bookingProductType == productType && settings.bookingMethod == 0) {
















    flag = true;
  }
  return flag;
}

//初始化预订方式
function initBookMethod(productType, isInternational) {
  let settings = app.GetSettings();
  let flag = true;

  if (productType == 1) {
    if (isInternational) {
      if (!settings.IsPermittedBookInternationalHotel) {
        flag = false;
      }
    } else {
      if (!settings.IsPermittedBookHotel) {
        flag = false;
      }
    }
  }
  if (productType == 5) {
    if (!isInternational) {
      if (!settings.IsPermittedBookFlight) {
        flag = false;
      }
    } else {
      if (!settings.IsPermittedBookInternationalFlight) {
        flag = false;
      }
    }
  } else if (productType == 6) {
    if (!settings.IsPermittedBookTrain) {
      flag = false;
    }
  } else if (productType == 7) {
    if (!settings.IsPermittedUseCar && !settings.IsPermittedUseCarTemp && !settings.IsPermittedUseCarWork) {
      flag = false;
    }
  }

  return flag;
}

function checkStandard(productType, isInternational, planeType, version, ispoint, hotelId) {
  let settings = app.GetSettings();
  let flag = true;
  if (settings.bookingMethod == 1) {
    ispoint = 0;
  }
  let pointUrl = ispoint == 1 ? 'ispoint=' + ispoint : '';
  if (productType == 1) {
    let url2, url3, url4;
    if (hotelId) {
      url4 = `/pages/product3.0/hotel/detail/detail?Hid=${hotelId}&isInternational=0`;
    } else {
      url2 = '/pages/product2.0/hotel/list/list?' + pointUrl;
      url3 = '/pages/product3.0/hotel/list/list?' + pointUrl;
    }
    let hotelurl = isInternational ? url2 : hotelId ? url4 : url3;
    if (isInternational) {
      if (!settings.IsPermittedBookInternationalHotel && settings.bookingMethod != 0) {
        flag = false;
      } else {
        customer.checkLogin(hotelurl);
      }
    } else {
      if (!settings.IsPermittedBookHotel && settings.bookingMethod != 0) {
        flag = false;
      } else {
        customer.checkLogin(hotelurl);
      }
    }
  }
  if (productType == 5) {
    if (!isInternational) {
      if (settings.IsPermittedBookFlight || settings.bookingMethod == 0) {
        pointUrl = pointUrl ? '&' + pointUrl : '';
        if (version == '2.0') {
          customer.checkLogin('/pages/product3.0/flight/list?lineType=' + planeType + pointUrl);
        } else {
          customer.checkLogin('/pages/flight/list/list?lineType=' + planeType + pointUrl);
        }
      } else {
        flag = false;
      }
    } else {
      if (settings.IsPermittedBookInternationalFlight || settings.bookingMethod == 0) {
        if (planeType == 0) {
          customer.checkLogin('/pages/product2.0/national_flight/list/list' + pointUrl);
        } else if (planeType == 1) {
          customer.checkLogin('/pages/product2.0/national_flight/list/list_go_back' + pointUrl);
        }
      } else {
        flag = false;
      }
    }
  } else if (productType == 6) {
    if (!settings.IsPermittedBookTrain && settings.bookingMethod != 0) {
      flag = false;
    }
  } else if (productType == 7) {
    if (
      !settings.IsPermittedUseCar &&
      !settings.IsPermittedUseCarTemp &&
      !settings.IsPermittedUseCarWork &&
      settings.bookingMethod != 0
    ) {
      flag = false;
    }
  }

  if (!flag) {
    let typeName = '';
    switch (productType) {
      case 1:
        if (isInternational) {
          typeName = settings.InternationalHotelCanNotBookingMsg || '';
        } else {
          typeName = settings.HotelCanNotBookingMsg || '';
        }
        break;
      case 5:
        if (isInternational) {
          typeName = settings.InternationalFlightCanNotBookingMsg || '';
        } else {
          typeName = settings.FlightCanNotBookingMsg || '';
        }
        break;
      case 6:
        typeName = settings.TrainCanNotBookingMsg || '';
        break;
      case 7:
        typeName = settings.CarCanNotBookingMsg || '';
        break;
    }
    app.Confirm('提示', typeName, '知道了', '', false);
  }
  return flag;
}

//验证是否可以使用业务线
function getBusinessCanUsed(productType, isInternational) {
  let settings = app.GetSettings();
  let flag = true;

  if (productType == productTypeConfig.hotel) {
    if (isInternational) {
      if (!settings.IsPermittedBookInternationalHotel && settings.bookingMethod != 0) {
        flag = false;
      }
    } else {
      if (!settings.IsPermittedBookHotel && settings.bookingMethod != 0) {
        flag = false;
      }
    }
  } else if (productType == productTypeConfig.flight) {
    if (!isInternational) {
      if (!settings.IsPermittedBookFlight && settings.bookingMethod != 0) {
        flag = false;
      }
    } else {
      if (!settings.IsPermittedBookInternationalFlight && settings.bookingMethod != 0) {
        flag = false;
      }
    }
  } else if (productType == productTypeConfig.train) {
    if (!settings.IsPermittedBookTrain && settings.bookingMethod != 0) {
      flag = false;
    }
  }
  if (!flag) {
    let tip = '';
    switch (productType) {
      case 1:
        if (isInternational) {
          tip = settings.InternationalHotelCanNotBookingMsg || '';
        } else {
          tip = settings.HotelCanNotBookingMsg || '';
        }
        break;
      case 5:
        if (isInternational) {
          tip = settings.InternationalFlightCanNotBookingMsg || '';
        } else {
          tip = settings.FlightCanNotBookingMsg || '';
        }
        break;
      case 6:
        tip = settings.TrainCanNotBookingMsg || '';
        break;
      case 7:
        tip = settings.CarCanNotBookingMsg || '';
        break;
    }
    app.Confirm('提示', tip, '知道了', '', false);
  }
  return flag;
}

export default {
  setIsTravelBussiness,
  checkStandard,
  initHeader,
  initBookMethod,
  getBusinessCanUsed,
};
